<template>
  <b-card title="Số lượng Giảng viên và Lớp độc lập">
    <app-echart-bar
      :option-data="createClassesAndEmployeesByDepartmentEchartBar"
    />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import AppEchartBar from '@core/components/charts/echart/AppEchartBar.vue'
import { SEMESTER_NAME } from "@/const/status";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BCard,
    AppEchartBar,
  },
  props: {
    filter: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      createClassesAndEmployeesByDepartmentEchartBar: {
        xAxis: {
          type: 'category',
          data: [],
        },
        yAxis: [
          {
            type: 'value',
            splitLine: { show: false },
          },
        ],
        grid: {
          left: '40px',
          right: '30px',
          bottom: '30px',
        },
        series: [
          {
            name: 'Giảng viên',
            type: 'bar',
            stack: 'advertising',
            data: [],
            barMaxWidth: '20%',
            barMinWidth: '10px',
            color: '#FDAC34',
          },
          {
            name: 'Lớp độc lập',
            type: 'bar',
            stack: 'advertising',
            data: [],
            barMaxWidth: '20%',
            barMinWidth: '10px',
            color: '#28dac6',
            itemStyle: {
              barBorderRadius: [ 10, 10, 0, 0 ],
            },
          },
        ],
      },
    }
  },
  watch: {
    'filter.trainingSystemId': async function () {
      await this.getDataFromStore()
    },
    'filter.yearId': async function () {
      await this.getDataFromStore()
    },
    'filter.semesterId': async function () {
      await this.getDataFromStore()
    }
  },
  computed: {
    ...mapGetters( {
      countTeachersAndCreditClassByDepartment: 'chart/countTeachersAndCreditClassByDepartment'
    }),
  },
  async created() {
    await this.getDataFromStore()
  },
  methods:{
    ...mapActions({
      getTeachersAndCreditClassByDepartment: 'chart/getTeachersAndCreditClassByDepartment'
    }),
    async getDataFromStore(){
      this.isLoading = true
      try {
        await this.getTeachersAndCreditClassByDepartment(this.filter)
        if (this.countTeachersAndCreditClassByDepartment.length > 0) {
          this.createClassesAndEmployeesByDepartmentEchartBar.xAxis.data = []
          this.createClassesAndEmployeesByDepartmentEchartBar.series[0].data = []
          this.createClassesAndEmployeesByDepartmentEchartBar.series[1].data = []
          this.countTeachersAndCreditClassByDepartment.forEach((item, key) => {
            this.createClassesAndEmployeesByDepartmentEchartBar.xAxis.data.push(this.countTeachersAndCreditClassByDepartment[key].departmentName)
            this.createClassesAndEmployeesByDepartmentEchartBar.series[0].data.push(this.countTeachersAndCreditClassByDepartment[key].countTeachersCreditClasses)
            this.createClassesAndEmployeesByDepartmentEchartBar.series[1].data.push(this.countTeachersAndCreditClassByDepartment[key].countCreditClasses)
          })
        }
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
  }
}
</script>
